import classNames from 'classnames';
import { FC } from 'react';
import { MarketplaceFeaturesParams } from '../../constants/marketplace';
import { MarketplaceFeatureKey } from '../../types/marketplace';
import { SCREENS } from '~/constants/screens';
import { COLORS } from '~/constants/styles';
import { localeStore } from '~/mobx/localesStore';
import { history } from '~/services/history';
import { formatImagePath } from '~/utils/formatter';
import Label, { TLabelTheme } from '~/view/components/Controls/Label';
import './style.scss';

interface IProps {
  featureKey: MarketplaceFeatureKey;
  status: boolean;
  purchased: boolean;
}

const labelOptions = {
  BUY: { color: COLORS.MAINBLUE, text: 'BUY', className: null },
  ON: { color: COLORS.WHITE, text: 'ON', className: 'color-mainblue' },
  OFF: { color: COLORS.WHITE, text: 'OFF', className: 'color-red' },
};

const MarketplaceItem: FC<IProps> = ({ featureKey, status, purchased }): JSX.Element => {
  const { name: featureName, title, description, iconName, backgroundColor } = MarketplaceFeaturesParams[featureKey] || { name: '', image: '' };

  const {
    color: labelColor,
    text: labelText,
    className: labelClassName,
  } = purchased ? (status ? labelOptions.ON : labelOptions.OFF) : labelOptions.BUY;

  const handleClick = () => {
    history.push(SCREENS.MARKETPLACE_FEATURE(featureKey));
  };

  return (
    <div className="marketplace-item" onClick={handleClick}>
      <div className="marketplace-item__image-wrapper" style={{ backgroundColor: backgroundColor || 'transparent' }}>
        <img src={formatImagePath(`${iconName || featureName}.svg`)} alt="Img" />
      </div>
      <div className="marketplace-item__info">
        <div className="align-self-start">
          <p className="family-semibold text-size-18 mb-2">{localeStore.t(title || featureName)}</p>
          <p className="family-regular text-size-14 color-gray3 marketplace-item__info_desc">
            {localeStore.t(description || featureName + '_description')}
          </p>
        </div>
        <Label text={labelText} color={labelColor as TLabelTheme} className={classNames('mx-2', labelClassName)} />
      </div>
    </div>
  );
};

export default MarketplaceItem;
